import { t } from 'i18next';
import { type Control, Controller } from 'react-hook-form';

import { CONTAINER_DELIVERIES_DROP_OFF_SIZE } from '../../../config/constants';
import Input from '../../atoms/Inputs/Input';
import ButtonsManifestCarousel from '../../molecules/ButtonsManifestCarousel';

type ContainerDeliveriesFormProps = {
  control: Control<any, any>;
  stop: any;
  containerDropOffSize: string;
  setContainerDropOffSize: (size: string) => void;
};

export const ContainerDeliveriesForm = ({
  control,
  stop,
  containerDropOffSize,
  setContainerDropOffSize,
}: ContainerDeliveriesFormProps) => {
  return (
    <div className="flex flex-col gap-2">
      <Input
        control={control}
        inputField="serviceType"
        defaultValue={stop.serviceType || ''}
        label={t('manifest.serviceType')}
        type="text"
        disabled={true}
      />
      {stop.serviceType !== 'Only Drop Off' && (
        <Input
          control={control}
          inputField="serviceContainerSizePickUp"
          defaultValue={stop.serviceContainerSizePickUp || ''}
          label={t('manifest.containerPickUp')}
          type="text"
          disabled={true}
        />
      )}
      {/* <Input
        control={control}
        inputField="serviceContainerSizeDropOff"
        defaultValue={stop.serviceContainerSizeDropOff || ''}
        label={t('manifest.containerDropOff')}
        type="text"
        disabled={true}
      /> */}
      <p className="text-sm text-ReyesBlack">
        {t('manifest.containerDropOff')}
      </p>
      <Controller
        name="serviceContainerSizeDropOff"
        control={control}
        defaultValue=""
        rules={{ required: `${t('manifest.dropdownError')}` }}
        render={({ field }) => (
          <ButtonsManifestCarousel
            field={field}
            options={CONTAINER_DELIVERIES_DROP_OFF_SIZE}
            setState={(size: any) =>
              setContainerDropOffSize(size[0].replace(' Gal', ''))
            }
            state={
              containerDropOffSize !== 'Special Requirements'
                ? `${containerDropOffSize} Gal`
                : containerDropOffSize
            }
          ></ButtonsManifestCarousel>
        )}
      />
      {/* It cannot be modified so we compare it with the stop info */}
      {containerDropOffSize === 'Special Requirements' && (
        <Input
          control={control}
          inputField="serviceSpecialRequirements"
          defaultValue={stop.serviceSpecialRequirements || ''}
          label={t('manifest.specialRequirements')}
          type="text"
        />
      )}
      <Input
        control={control}
        inputField="comments"
        defaultValue={''}
        label={t('manifest.comments')}
        type="text"
      />
    </div>
  );
};
